import { api } from "../base";

const refdataEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /** Fetches market-data-enabled instrument symbols for a venue. */
    getVenueInstruments: build.query<
      string[],
      {
        venue: string;
        symbolOnly?: boolean;
      }
    >({
      query: ({ venue, symbolOnly = true }) => ({
        url: "/api/refdata/v1/instruments",
        params: {
          venue,
          market_data_enabled: false,
          symbol_only: symbolOnly,
        },
      }),
      transformResponse: (response: string[] | { data: string[] }) =>
        Array.isArray(response) ? response : (response.data ?? []),
      providesTags: ["RefdataInstruments"],
    }),

    /** Fetches all instrument symbols (no venue filter). */
    getInstrumentSymbols: build.query<string[], void>({
      query: () => ({
        url: "/api/refdata/v1/instruments",
        params: { symbol_only: true },
      }),
      transformResponse: (response: string[] | { data: string[] }) =>
        Array.isArray(response) ? response : (response.data ?? []),
      providesTags: ["RefdataInstruments"],
    }),

    /** Fetches venue codes. */
    getVenueCodes: build.query<string[], void>({
      query: () => ({ url: "/api/refdata/v1/venue_codes" }),
      transformResponse: (response: string[] | { data: string[] }) =>
        Array.isArray(response) ? response : (response.data ?? []),
    }),
  }),
});

export const {
  useGetVenueInstrumentsQuery,
  useLazyGetVenueInstrumentsQuery,
  useGetInstrumentSymbolsQuery,
  useGetVenueCodesQuery,
} = refdataEndpoints;
